<div class="reading-room-page page">
  <div class="heading-wrapper">
    <h4>{{ 'pages.readingRoom.title' | translate }}</h4>
    <div class="actions">
      <button
        class="primary add-btn"
        [policyType]="CLAIM_SCOPE"
        [claimType]="CLAIM_TYPES['create']"
        (click)="navigateToAddPage()"
        appPermission>
        <img src="assets/images/add-icon-white.svg" alt="add-icon-white.svg" />
        {{ 'pages.readingRoom.addReadingRoom' | translate }}
      </button>
      <button
        class="secondary download-excel"
        [disabled]="isExcelDownloading"
        [ngClass]="{ downloading: isExcelDownloading }"
        (click)="getExcelFile()">
        @if (!isExcelDownloading) {
          <img src="assets/images/download-excel.svg" alt="download-excel.svg" />
          {{ 'pages.readingRoom.saveExcel' | translate }}
        } @else {
          <div class="spinner-wrapper">
            <div class="spinner"></div>
          </div>
        }
      </button>
    </div>
  </div>
  <app-table
    [columns]="tableColumns"
    [endpoint]="apiPath"
    [withPagination]="true"
    [flatTopBorder]="true"
    viewEntryPath="/lasitava/{id}"
    editEntryPath="/lasitavas/rediget/{id}" />
</div>
